module.exports = __webpack_public_path__ + "ClientApp/content/vet_tes_masthead.png";